import React from "react";
import Reveal, { RevealMedia } from "./Reveal";
import profileImg from "../assets/images/profile.jpg";

const Profile = () => (
  <section className="act profile" id="profile">
    <div className="act__inner">
      <Reveal>
        <span className="act__num">03 — Hakkımda</span>
      </Reveal>
      <Reveal as="h2" className="act__title" delay={0.05}>
        Kısaca <em>ben</em>
      </Reveal>

      <div className="profile__body">
        <RevealMedia>
          <img
            className="profile__portrait"
            src={profileImg}
            alt="Mücahit Tünel"
            loading="lazy"
          />
        </RevealMedia>

        <div>
          <Reveal className="profile__stanzas" delay={0.1}>
            <p>
              React Native ile tanıştığım günden beri tek işim mobil uygulama
              geliştirmek. Bir fikri alıp App Store ve Google Play'de yayında
              olan bir ürüne dönüştürüyorum; arayüz kurgusu, state yönetimi,
              native modül entegrasyonu, performans optimizasyonu, test ve mağaza
              süreçleri dahil.
            </p>
          </Reveal>
          <Reveal as="p" className="profile__quote" delay={0.16}>
            İyi bir mobil ürünün, kullanıcının hiç fark etmediği yüzlerce küçük
            kararın toplamı olduğuna inanıyorum.
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Profile;
